"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverdayEventDivider = void 0;
const lodash_1 = require("lodash");
const divideOverDayPeriodFilter_1 = require("./periodFilters/divideOverDayPeriodFilter");
class OverdayEventDivider {
    /**
     * まとめて分割できるくん
     * @param events
     * @returns
     */
    static divideAll(events) {
        const dividedEvents = events.map((ev) => this.divide(ev));
        return (0, lodash_1.flatten)(dividedEvents);
    }
    /**
     * 日を跨ぐイベントを日の境界線で分割する
     * @param event
     * @returns event | events 分割されたイベント
     */
    static divide(event) {
        const periods = (0, divideOverDayPeriodFilter_1.divideOverDayPeriod)(event.period);
        if (!Array.isArray(periods)) {
            return event;
        }
        return periods.map((period, index) => {
            return Object.assign(Object.assign({}, event), {
                id: `${event.id}_${index}`,
                period
            });
        });
    }
}
exports.OverdayEventDivider = OverdayEventDivider;
//# sourceMappingURL=overdayEventDivider.js.map